import React from 'react';
import './ConsultationCTA.scss';
import { BsFillArrowRightCircleFill } from "react-icons/bs";

const ConsultationCTA = () => {
    return (
        <section className='consultation-cta-section pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="cta-content">
                            <h2>Ready to Transform Your Smile?</h2>
                            <p>
                                Book a consultation with Dr. Mishqah Dollie to discuss your dental needs and create a personalized treatment plan. Our experienced team is here to help you achieve optimal oral health and the smile you deserve.
                            </p>
                            <div className="cta-buttons">
                                <a 
                                    href='https://www.recomed.co.za/dentist/cape-town/mishqah-dollie/7579/7349/' 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="btn-primary"
                                    aria-label="Book your dental consultation with Dr Mishqah Dollie in Ottery, Cape Town"
                                >
                                    Book Your Consultation
                                    <BsFillArrowRightCircleFill aria-hidden="true"/>
                                </a>
                                <a 
                                    href="tel:+27212345678" 
                                    className="btn-secondary"
                                    aria-label="Call our dental practice for immediate assistance"
                                >
                                    Call Now
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConsultationCTA;
